import {createMuiTheme} from 'material-ui'
import indigo from 'material-ui/colors/indigo'
import red from 'material-ui/colors/pink';

const muiTheme = createMuiTheme({
    overrides: {
        MuiInput: {
            root: {
                fontSize: 16
            }
        }
    },
    palette: {
        primary: indigo,
        secondary: red,
        error: red,
        type: 'light'
    }
});

export default muiTheme;


// WEBPACK FOOTER //
// ./src/conf/mui-theme.js